module.exports = __webpack_public_path__ + "img/slide12.6ff64dcf.png";